import {toInt, isInt, isISO8601, isURL} from 'validator';
import moment from 'moment';

export const requiredDate = (value, displayName) => {
	let errorMessage = undefined;
	errorMessage = required(value, displayName);
	if(!errorMessage) {
		errorMessage = validDate(value, displayName);
	}
	return errorMessage;
};

export const endDateAfterStartDate = (startDate, endDate, laterLabel, earlierLabel) => {
	let errorMessage = undefined;
	let momentStartDate = moment(startDate);
	let momentEndDate = moment(endDate);

	if (momentStartDate.isAfter(momentEndDate)){
		errorMessage = `${laterLabel} must be after ${earlierLabel}.`;
	}
	return errorMessage;
};

export const required = (value, displayName) => {
	let errorMessage = '';

	if (value && value.constructor === Array) {
		if (value.length < 1) {
			errorMessage = `${displayName} is required.`;
		}
	} else {
		if (!value) {
			errorMessage = `${displayName} is required.`;
		}
	}
	return errorMessage;
};

export const requiredURL = (value, displayName) => {
	let errorMessage = '';

	if (value === "https://" || value === "http://" || value === "") {
		errorMessage = `${displayName} is required.`;
	}

	return errorMessage;
};

export const validURL = (value, displayName, options = {}) => {
	let errorMessage = '';

	if (!isURL(value, options)) {
		errorMessage = `${displayName} is not a valid URL.`;
	}
	return errorMessage;
};

export const validDate = (value, displayName) => {
	let errorMessage = undefined;
	let strValue = moment(value).format();
	if(!strValue || !isISO8601(strValue)){
		errorMessage = `${displayName} must be a valid date.`;
	}
	return errorMessage;
};

export const requiredPositiveNumber = (value, displayName) => {
	let errorMessage = undefined;
	errorMessage = required(value, displayName);
	if(!errorMessage) {
		let intVal = toInt(value);
		if(isNaN(intVal) || value <= 0){
			errorMessage = `${displayName} must be greater than 0.`;
		}
	}
	return errorMessage;
};

export const requiredNonNegativeNumber = (value, displayName) => {
	let errorMessage = undefined;
	errorMessage = required(value, displayName);
	if(!errorMessage) {
		let intVal = toInt(value);
		if(isNaN(intVal) || intVal < 0){
			errorMessage = `${displayName} must be 0 or greater.`;
		}
	}
	return errorMessage;
};

export const requiredToggle = (toggleValue) => {
	let errorMessage = '';
	if(toggleValue === undefined){
		errorMessage = 'Please select "Yes" or "No".';
	}
	return errorMessage;
};

export const maxFieldLength = (value, fieldLength, errorMessageVal) => {
	let errorMessage = undefined;
	if (value.length > fieldLength){
		errorMessage = `${errorMessageVal} cannot exceed ${fieldLength} characters.`;
	}
	return errorMessage;
};

export const maxFileSize = (fileSize) => {
	let errorMessage = '';
	if (fileSize > 1000000) {
		errorMessage = "File must be 1 MB or smaller.";
	}
	return errorMessage;
};

export const validFileType = (fileType, errorMessageVal) => {
	let errorMessage = '';
	if (fileType !== "image/jpeg" && fileType !== "image/png") {
		errorMessage = `${errorMessageVal} must be JPEG or PNG.`;
	}
	return errorMessage;
};

export const validIP = (IPAddress) => {
	let errorMessage = '';
	if (!/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))$/.test(IPAddress)) {
		errorMessage = 'Invalid IP Address.';
	}
	return errorMessage;
};

/*atomic validators */


export const nonDecimal = (value, errorMessageVal = 'cannot be a decimal number.') => {
	let errorMessage = undefined;
	let stringVal = value.toString();
	if(!isInt(stringVal)){
		errorMessage = errorMessageVal;
	}
	return errorMessage;
};

export const nonNegative = (value, errorMessageVal = 'must be 0 or greater.') => {
	let errorMessage = undefined;
	let stringVal = value.toString();
	let intVal = toInt(stringVal);
	if(isNaN(intVal) || intVal < 0){
		errorMessage = errorMessageVal;
	}
	return errorMessage;
};



/*validators that use a combination of atomic ones e.g. nonNegative and nonNegative can be a nonNegativeInteger */


export const requiredValue = (value, errorMessageVal = 'value is required.') => {
	let errorMessage = undefined;
	if(!value){
		errorMessage = errorMessageVal;
	}
	return errorMessage;
};

export const nonNegativeInteger = (value, errorMessageVal = 'must be a whole number zero or greater.') => {
	let errorMessage = undefined;
	let stringVal = value.toString();
	errorMessage = nonNegative(stringVal);

	if(nonNegative(stringVal) || nonDecimal(stringVal)){
		/*we found an error*/
		errorMessage = errorMessageVal;
	}
	return errorMessage;
};

export const greaterThanOrEqualTo = (conditionValue, errorMessage) => val => {
	if (!errorMessage) errorMessage = `Value must be greater than or equal to ${conditionValue}`;
	let passes = Number(val) >= Number(conditionValue);
	if(passes) return null;
	else return errorMessage;
};